import $ from "jquery";
import Backbone from "backbone";
import Validation from "backbone-validation";
import Marionette from "backbone.marionette";

import events from "js/events";
import positionModels from "js/models/positions";
import tmpl from "js/templates/steps";
import { scroll } from "js/views/app/util";

const BaseStep = Marionette.View.extend({
    className: "form-step",
    modal: null,
    attachElContent(html) {
        if (this.options.isProfile) {
            html += tmpl.Btns();
        }

        this.$el.html(html);
        return this;
    },
    ui: {
        backBtn: ".btn-end-step",
        saveBtn: ".save-changes",
    },
    events: {
        "click @ui.backBtn": "endStep",
        "click @ui.saveBtn": "onSave",
        "keyup textarea": "adjustTextareaHeight",
    },
    initialize(...args) {
        this.onRegionShown = this.onRegionShown.bind(this);
        this.showNextButton = true;
        this.textareaBorderBox = false;

        this.postInit(...args);
    },
    postInit() {},
    onRegionShown(region) {
        // animated region's transforms mess up position: fixed elements
        region.$el.css("transform", "none");

        if (this.showNextButton) {
            this.getNextButton().fadeIn();
        }

        // because of animation timing, swapping the step_* class name has
        // to happen this way to avoid glitching on the outgoing step
        if (this.name) {
            let content = $(".application.content");
            if (content.length) {
                content = content[0];
                const stepClass = this.name.toLowerCase();
                content.className = content.className.replace(/step_[\S]{1,}/g, "") + stepClass;
            }
        }

        this.afterRegionShown(region);
    },
    afterRegionShown() {},
    adjustTextareaHeight(e) {
        const $el = $(e.target);
        if (e.target.scrollHeight > $el.outerHeight()) {
            let lineHeight = 28;
            if (this.textareaBorderBox) {
                lineHeight += 40; // padding-top + padding-bottom;
            }
            $el.css("height", `${$el.height() + lineHeight}px`);
        }
    },
    endStep() {
        this.onDestroy();
        this.model.trigger("step:end", false);
    },
    onSave(e) {
        e.preventDefault();

        this.save();
    },
    save() {
        if (this.submit()) {
            this.ui.saveBtn.prop("disabled", true);
            this.ui.saveBtn.siblings(".loader").show();
            this.onDestroy();
            this.model.trigger("step:end", true);
            if (!this.options.isReview) {
                events.track("PROFILE_SAVE", this.name);
            }
        }
    },
    onRender() {
        this.bindUIElements();
        Backbone.Radio.channel("region").on("region:shown", this.onRegionShown);

        if (this.name) {
            $(".application.content").addClass(this.name.toLowerCase());
        }

        Validation.bind(this);
        if (!this.modal) {
            this.bindNextStep();
            this.listenTo(this.model, "step:next", this.onDestroy);
        }

        this.postRender();
    },
    getNextButton() {
        return $(".next-button");
    },
    onDestroy() {
        this.bound = false;
        this.getNextButton().off(`click.${this.cid}`);
        this.stopListening(this.model);
        Backbone.Radio.channel("region").off("region:shown", this.onRegionShown);

        this.postDestroy();
    },
    bindNextStep() {
        if (this.bound) {
            return;
        }

        this.bound = true;
        this.getNextButton().on(`click.${this.cid}`, () => {
            if (this.options.isProfile) {
                this.save();
            } else if (this.submit()) {
                this.nextStep();
            } else {
                scroll();
            }
        });
    },
    setPositions(data) {
        if (data) {
            this.positions = new positionModels.Positions(data);
        }
    },
    prevStep() {
        this.model.trigger("step:prev");
    },
    nextStep() {
        this.model.trigger("step:next");
    },
    postRender() {},
    postDestroy() {},
    shouldSkip() {
        return false;
    },
    submit() {
        return this.model.set(this.getData(), { validate: "partial" });
    },
});

const AddStep = BaseStep.extend({
    template: false,
    postInit() {
        this.showNextButton = false;
    },
    render(_model) {
        this.addModel(_model);

        this.modal = this.$el.modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
        $(".content").addClass("noscroll");

        this.$el.on("modal:close", () => {
            $(".content").removeClass("noscroll");
            $(".add-step-submit").unbind(`click.${this.model.cid}`);
            this.resetForm();
            this.trigger("modal:close");
        });

        $(".add-step-submit").bind(`click.${this.model.cid}`, () => {
            this.submit();
        });

        this.onRender();
        return this;
    },
    submit() {
        const valid = this.model.set(this.getData(), { validate: "partial" });
        if (valid) {
            this.trigger("modal:save");
            $(".add-step-submit").unbind(`click.${this.model.cid}`);
            this.resetForm();
        } else {
            scroll();
        }
    },
    resetForm() {
        $(".add-form").each((idx, form) => {
            form.reset();
        });
        this.reset();
    },
    reset() {},
});

export { AddStep, BaseStep };
